import { z } from 'zod';
import { equipmentValidationPatterns, equipmentValidationMessages, } from './constants';
// Equipment validation schema
const equipmentSchema = z.object({
    assetType: z.enum(['container', 'chassis', 'trailer']),
    equipmentNumber: z.string().trim().min(1, 'Equipment number is required'),
});
// Add Leg form schema
export const addLegSchema = z.object({
    legType: z.string().min(1, 'Leg type is required'),
    equipment: z
        .array(equipmentSchema)
        .min(1, 'At least one equipment is required'),
    totalWeight: z.string().min(1, 'Total weight is required'),
    weightUnit: z.string().min(1, 'Weight unit is required'),
    pickupName: z.string().min(1, 'Pickup location name is required'),
    pickupAddress: z.string().min(1, 'Pickup address is required'),
    deliverName: z.string().min(1, 'Delivery location name is required'),
    deliverAddress: z.string().min(1, 'Delivery address is required'),
    carrier: z.string().optional(),
    specialInstructions: z.string().optional(),
});
// Add Hub form schema
const requiredString = (message) => z.preprocess((val) => (typeof val === 'string' ? val : ''), z.string().trim().min(1, message));
export const addHubSchema = z.object({
    hubbingType: z.enum(['pre_pull', 'stop_off', 'yard_diversion']),
    street: requiredString('Street address is required'),
    city: requiredString('City is required'),
    state: requiredString('State is required'),
    zip: requiredString('Zip code is required'),
    address: z.string().optional(),
    specialInstructions: z.string().optional(),
    // Optional name when a custom yard name is set
    name: z.string().optional(),
    // yardId is optional now and not required by validation
    yardId: z.string().optional(),
});
// Helper function to validate equipment format and return warnings
export function validateEquipmentFormat(equipmentNumber, assetType) {
    if (!equipmentNumber)
        return null;
    const typeKey = (assetType || '').toLowerCase();
    const pattern = equipmentValidationPatterns[typeKey];
    const message = equipmentValidationMessages[typeKey];
    if (!pattern)
        return null;
    if (!pattern.test(equipmentNumber)) {
        return message;
    }
    return null;
}
